import React, { useState, useRef } from 'react'
import DatePicker from 'react-multi-date-picker';
import { useProjectTimesheetDetails } from '../../../Hooks/Features/ProjectHighlight/useProjectTimesheetDetails';
import { AgGridReact } from '@ag-grid-community/react';
import { SkeletonDataTable } from '../../../components/Loader/Loader';
import { useCommon } from '../../../Hooks/Common/useCommon';
import CommonFilterDropdown from '../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ProjectTimesheetDetails = () => {

  const { filterValue, setFilterValue, getProjectWiseTimesheetSummary, gridRef, columnDefs, rowData, loader, tagRef } = useProjectTimesheetDetails()
  const { checkPermission } = useCommon();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const datePickerRef = useRef(null);

  return (
    <div ref={() => checkPermission('Sidebar', tagRef)}>
      <div className="d-flex align-items-center justify-content-between gap-3 w-100 mt-2 px-3" ref={tagRef} id='{"tabname": "sidebar", "data": "project_timesheet_details_tab"}'>
        <div className="d-flex align-items-center gap-2 flex-grow-1">
        </div>
        <div className="d-flex justify-content-end gap-2">
          <button className="sk-btn sk-btn-primary rounded" onClick={() => getProjectWiseTimesheetSummary()} title="Refresh">
            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
          </button>
          <button className="sk-btn sk-btn-primary rounded" onClick={() => setShowFiltersDrawer(true)} title="Filters">
            <FontAwesomeIcon icon="fa-solid fa-filter" />
          </button>
        </div>
      </div>
      {
        loader ? <SkeletonDataTable numSkeletons={20} /> : <div className="ag-theme-alpine" style={{ height: "calc(100vh - 120px)", width: '100%' }}>
          <AgGridReact
            ref={gridRef}
            columnDefs={columnDefs}
            rowData={rowData}
            headerHeight={40}
          />
        </div>
      }

      {/* Right Panel Filters Drawer */}
      <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
        <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
          <div className="sk-drawer-header">
            <h5 className="sk-drawer-title">Filters</h5>
            <div className="d-flex align-items-center gap-2">
              <button className="sk-drawer-clear-btn" onClick={() => {
                setFilterValue((prev) => ({
                  ...prev,
                  hoveredRange: [null, null],
                  projects: [],
                  users: [],
                  project_leads: [],
                  apiCall: true
                }));
              }}>Clear All</button>
              <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                <FontAwesomeIcon icon="fa-solid fa-xmark" />
              </button>
            </div>
          </div>
          <div className="sk-drawer-body">
            <div className='d-flex flex-column gap-4'>
              {/* Date Picker Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Date Range</div>
                <DatePicker
                  ref={datePickerRef}
                  value={filterValue?.hoveredRange}
                  onChange={(date) => {
                                            if (!date || date.length === 2) {
                                                setFilterValue((prev) => ({ ...prev, hoveredRange: date, isChange: true }));
                    if (date && date.length === 2) {
                      datePickerRef.current?.closeCalendar();
                    }
                                            }
                                        }}
                  range
                  rangeHover
                  numberOfMonths={2}
                  style={{ width: "100%" }}
                  containerStyle={{ width: "100%" }}
                  inputClass="w-100 sk-input-dd"
                  placeholder="Select Dates"
                />
              </div>

              {/* Dimensions Dropdown Filters */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Dimensions</div>
                <CommonFilterDropdown
                  fields={[
                    { key: "projects", label: "Projects", col: 12 },
                    { key: "users", label: "Users", col: 12 },
                    { key: "project_leads", label: "Leads", col: 12 }
                  ]}
                  filterValues={filterValue}
                  setFilterValues={setFilterValue}
                />
              </div>
            </div>
          </div>
          <div className="sk-drawer-footer">
            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
              getProjectWiseTimesheetSummary();
              setShowFiltersDrawer(false);
            }}>Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProjectTimesheetDetails





